import React, { useContext, useState, createContext } from 'react';
import { ActivityModel } from '../../containers/leads/components/activities/add-activity';

export interface IUseLeadCalendarContext {
  children?: any;
  selectedDate: Date;
  setSelectedDate: (date: Date) => void;
  showCalendar: boolean;
  setShowCalendar: (value: boolean) => void;
  selectedAssignee?: string;
  setRelaodTrigger: (value: boolean) => void;
  relaodTrigger?: boolean;
  setSelectedAssignee: (value: string) => void;
  initialData?: ActivityModel;
  setInitialData: (value: ActivityModel) => void;
}
export const postsContextDefaultValue: IUseLeadCalendarContext = {
  selectedDate: new Date(),
  setSelectedDate: (date) => null,
  showCalendar: false,
  setShowCalendar: (value) => null,
  relaodTrigger: false,
  setRelaodTrigger: (value) => null,
  setSelectedAssignee: (value) => null,
  setInitialData: (value) => null,
};

export const LeadCalendarContext = createContext<IUseLeadCalendarContext>(
  postsContextDefaultValue
);

export const LeadCalendarProvider = ({ children }: any) => {
  const [selectedDate, setSelectedDate] = useState<Date>(new Date());
  const [showCalendar, setShowCalendar] = useState<boolean>(false);
  const [relaodTrigger, setRelaodTrigger] = useState<boolean>(false);
  const [selectedAssignee, setSelectedAssignee] = useState<string>();
  const [initialData, setInitialData] = useState<ActivityModel | undefined>();

  return (
    <LeadCalendarContext.Provider
      value={{
        selectedDate,
        setSelectedDate,
        showCalendar,
        setShowCalendar,
        selectedAssignee,
        setSelectedAssignee,
        initialData,
        setInitialData,
        relaodTrigger,
        setRelaodTrigger,
      }}
    >
      {children}
    </LeadCalendarContext.Provider>
  );
};

export const useLeadCalendarContext = () => useContext(LeadCalendarContext);
